import React from 'react';
import { EngagementSpotlight as SpotlightEnabler } from '@atlassiansox/engagekit-ts';
import { useIsFullyExpanded } from '../../../controllers/is-fully-expanded/index.tsx';
import { withNestingOptimisation } from '../with-nesting-optimisation/index.tsx';
import type { EngagementSpotlightProps } from './types.tsx';

export const EngagementSpotlight = withNestingOptimisation<EngagementSpotlightProps>(
	({ engagementId }: EngagementSpotlightProps) => {
		const isFullyExpanded = useIsFullyExpanded();

		return isFullyExpanded && <SpotlightEnabler engagementId={engagementId} />;
	},
);
